const AbstractDojoRequestRecord = require('./AbstractCloverRequestRecord');

class CloverDeviceReadTipRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {number} baseAmount
     * @param {[{percentage: number},{percentage: number}]} tipSuggestions
     */
    constructor(baseAmount, tipSuggestions = []) {
        if (!baseAmount || !Number.isInteger(baseAmount)) {
            throw new Error('baseAmount is required and should be an integer number');
        }

        // @link https://docs.clover.com/reference/read_tip
        const url = '/connect/v1/device/read-tip';
        super(
            'POST',
            url,
        );
        this.data = {
            baseAmount,
            // @Todo We can optionally provide an array of tipSuggestion objects.
            tipSuggestions,
        };
    }
}

module.exports = CloverDeviceReadTipRequestRecord;
